import React, { useState, useEffect } from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { X, Phone, Plus, ArrowRight } from 'lucide-react';
import 'react-circular-progressbar/dist/styles.css';
import { VideoPopup } from '../../components/VideoPopup';
import { userService } from '../../services/userService';
import api from '../../lib/axios'; // Make sure this path is correct for your project
import Footer from '@/components/Footer';
import PostScryptContacts from './Dynamic_Form_parent/PostScryptContacts';
import useAuth from '@/hooks/stores/useAuth';






function ContactModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        <div className="p-6">
          <div className="relative mb-6">
            <h2 className="text-2xl font-bold text-gray-900 text-center">Contact Right Legal Group</h2>
            <button
              onClick={onClose}
              className="absolute right-0 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-500"
            >
              <X className="h-6 w-6" />
            </button>
          </div>

          <div className="text-center space-y-6">
            <p className="text-gray-600 text-lg">
              To make a change to your will, please contact Right Legal Group
            </p>
            
            <a 
              href="tel:01332424511"
              className="inline-flex items-center justify-center px-6 py-4 bg-[#F16745] text-white rounded-lg hover:bg-[#F16745] transition-colors group"
            >
              <Phone className="h-5 w-5 mr-3 animate-bounce group-hover:animate-none" />
              <span className="text-xl font-semibold">01332 424 511</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

function PostScryptContactsModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-900">PostScrypt Contacts</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-500"
            >
              <X className="h-6 w-6" />
            </button>
          </div>
          <PostScryptContacts onClose={onClose} />
        </div>
      </div>
    </div>
  );
}
















export const User_Dashboard = () => {
  const [showExecutorsModal, setShowExecutorsModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [progressValue, setProgressValue] = useState(0);
  const [loading, setLoading] = useState(true);
  const { userId } = useAuth();

  useEffect(() => {
    const fetchUserProgress = async () => {
      try {
        setLoading(true);
        const response = await userService.getUser(userId);
        const progress = response.progress || 0;
        setProgressValue(Math.round(progress)); // Round to nearest integer
      } catch (error) {
        console.error('Error fetching user progress:', error);
        setProgressValue(0); // Default to 0 on error
      } finally {
        setLoading(false);
      }
    };

    if (userId) {
      fetchUserProgress();
    }
  }, [userId]);

  return (
    <div className="min-h-screen bg-[#F1EBDB] pt-7">
      {/* <VideoPopup /> */}
      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow">
          <div className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="flex flex-col items-center justify-center space-y-6">
                <div className="flex items-center justify-center">
                  {loading ? (
                    <div className="w-32 h-32 flex items-center justify-center">
                      <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-[#F16745]"></div>
                    </div>
                  ) : (
                    <CircularProgressbar
                      value={progressValue}
                      text={`${progressValue}%`}
                      styles={buildStyles({
                        pathColor: '#F16745',
                        textColor: '#F16745',
                        trailColor: '#E5E7EB',
                        textSize: '16px'
                      })}
                      className="w-32 h-32"
                    />
                  )}
                </div>
                <div className="flex flex-col space-y-3 w-48">
                  <button
                    onClick={() => setShowExecutorsModal(true)}
                    className="w-full px-4 py-2 bg-[#F16745] text-white rounded-md hover:bg-[#E55D3D] focus:outline-none focus:ring-2 focus:ring-[#F16745] focus:ring-offset-2 transition-colors"
                  >
                    View executors
                  </button>
                  <button 
                    onClick={() => setShowContactModal(true)}
                    className="w-full px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors"
                  >
                    Make a change to your will
                  </button>
                </div>
              </div>

              {/* Right Column - CTA */}
              <div className="flex flex-col justify-center">
                <div className="bg-gradient-to-br from-[#F16745] to-[#E55D3D] p-8 rounded-lg shadow-lg transform hover:scale-[1.02] transition-transform">
                  <h3 className="text-2xl font-bold text-white mb-3">
                    Just to let you know
                  </h3>
                  <p className="text-white/90 mb-6 text-lg">
                    Your Form is waiting to be completed
                  </p>
                  <button 
                    onClick={() => window.location.href = '/form'}
                    className="w-full inline-flex items-center justify-center px-6 py-3 border-2 border-white text-base font-medium rounded-md shadow-sm text-white bg-transparent hover:bg-white hover:text-[#F16745] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#F16745] transition-colors"
                  >
                    Continue <ArrowRight className="ml-2 h-5 w-5" />
                  </button>
                </div>
              </div>
            </div>

            {/* Postscript Section */}
            <div className="mt-8 border-t pt-6">
            <div className="space-y-4 text-gray-600">
              <p>
                Each year, approximately 600,000 people pass away in the UK. As each generation goes by, the memory of those people begins to fade. They don&apos;t get remembered for who they were when they were young or what their dreams and ambitions were. They don&apos;t get to tell their story in their own words.
              </p>
              <p>
                PostScrypt allows you to provide both practical and sentimental guidance to those you leave behind.
              </p>
              <p>
                Whilst any information you provide in PostScrypt is not legally binding, the practical information you leave can support your loved ones and your Executors when they are administering your estate, ensuring that your affairs are dealt with promptly and in accordance with your wishes.
              </p>
              <p>
                PostScrypt also gives you the opportunity to detail your emotional wishes, including who you would like to leave your sentimental and personal belongings to and how you&apos;d like to be remembered at your funeral.
              </p>
              <p>
                We understand that the PostScrypt process can be emotional, but by completing each section, you can completely change the experience of family and friends when grieving the loss of their loved one. PostScrypt can and will be treasured by future generations, far beyond the distribution of your financial legacy.
              </p>
            </div>
            </div>
          </div>
        </div>
      </main>

      <PostScryptContactsModal
        isOpen={showExecutorsModal}
        onClose={() => setShowExecutorsModal(false)}
      />
      <ContactModal
        isOpen={showContactModal}
        onClose={() => setShowContactModal(false)}
      />
      <Footer/>
    </div>
  );
}
